import * as React from 'react';
import { CustomTooltip, LinkButton, IconTrust12 } from '@cian/ui-kit';

import {
  trackingActionClickPopupNV,
  trackReliableIconHover,
  trackReliableMoreButtonClick,
} from '../../actions/analytics';
import { Container } from '../../components/Container';
import { Text } from '../../components/Text';
import { TextAndIcon } from '../../components/TextAndIcon';
import { SIZE_12, SIZE_20, SIZE_28, SIZE_360, SIZE_4, SIZE_WIDE } from '../../constants/sizes';
import ReliableBuilderIcon from './icons/ReliableBuilderIcon.svg';

export interface IReliableChoicePopupProps {
  url: string;
  GKId: number;
}

interface IReliableChoicePopupState {
  isOpen: boolean;
}

export class ReliableChoicePopup extends React.PureComponent<IReliableChoicePopupProps, IReliableChoicePopupState> {
  public state: Readonly<IReliableChoicePopupState> = {
    isOpen: false,
  };

  private tooltipRef: React.RefObject<HTMLSpanElement>;

  public constructor(props: IReliableChoicePopupProps) {
    super(props);

    this.tooltipRef = React.createRef();
  }

  private onIconHover = () => {
    const { GKId } = this.props;
    trackReliableIconHover(GKId);
  };

  private onMoreButtonClick = () => {
    const { GKId } = this.props;
    trackingActionClickPopupNV();
    trackReliableMoreButtonClick(GKId);
  };

  public render() {
    const { isOpen } = this.state;

    let { url = '' } = this.props;

    if (url) {
      url = `${url}#reliable`;
    }

    return (
      <Container display="inline-block" onMouseEnter={this.onIconHover}>
        <span
          onMouseEnter={this.handleToggle(true)}
          onMouseLeave={this.handleToggle(false)}
          onClick={this.handleToggle(true)}
          ref={this.tooltipRef}
        >
          <TextAndIcon
            icon={<IconTrust12 color={isOpen ? 'fill_primary_active_100' : 'fill_primary_hover_100'} />}
            color="black"
            fontWeight="bold"
            alignItems="baseline"
            offset={4}
            fontSize={12}
          >
            Проверено ЦИАН
          </TextAndIcon>
          <CustomTooltip
            anchorRef={this.tooltipRef}
            open={isOpen}
            placement="bottom-start"
            outside={true}
            content={
              <div onMouseLeave={this.handleToggle(false)}>
                <Container
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  maxWidth={SIZE_WIDE}
                  width={SIZE_360}
                  padding={`${SIZE_12} 0 ${SIZE_28}`}
                >
                  <Container>
                    <img src={ReliableBuilderIcon} width="40px" height="40px" />
                  </Container>
                  <Container padding={`${SIZE_4} 0`}>
                    <Text fontSize={16} fontWeight="bold">
                      Проверено ЦИАН
                    </Text>
                  </Container>
                  <Text fontSize={14}>В ЖК есть корпуса, проверенные ЦИАН.</Text>
                  <Container padding={`${SIZE_20} 0 0`}>
                    <LinkButton
                      onClick={this.onMoreButtonClick}
                      href={url}
                      size="XS"
                      target="_blank"
                      theme="fill_secondary"
                    >
                      Узнать подробнее
                    </LinkButton>
                  </Container>
                </Container>
              </div>
            }
          />
        </span>
      </Container>
    );
  }

  private handleToggle = (value?: boolean) => () => {
    const { isOpen } = this.state;

    this.setState({ isOpen: value || !isOpen });
  };
}
